module.exports = __webpack_public_path__ + "img/ball_2.e6c3f6a3.png";